import { EVENTS, STATUS } from 'react-joyride';

/**
 * react-joyride v3 uses `onEvent`, not `callback`. Call from each tour's onEvent handler.
 */
export const shouldCompleteTutorialFromJoyrideEvent = (data) => {
  const { type, status } = data;
  return (
    type === EVENTS.TOUR_END
    || status === STATUS.FINISHED
    || status === STATUS.SKIPPED
  );
};

/** Scroll offset so targets aren't tucked under the fixed mobile bottom nav. */
export const JOYRIDE_MOBILE_SCROLL_OFFSET = 88;

/**
 * Shared Joyride options. v3 reads `options` / step fields — not `styles.options`
 * (that was the v2 API). Keep zIndex above BottomNav (1100) and MUI Drawer/Modal.
 */
export const JOYRIDE_OPTIONS = {
  zIndex: 2000,
  // Replaces the removed v2 `showSkipButton` prop.
  buttons: ['back', 'close', 'primary', 'skip'],
};

export const getJoyrideOptions = ({ isMobile = false } = {}) => ({
  ...JOYRIDE_OPTIONS,
  scrollOffset: isMobile ? JOYRIDE_MOBILE_SCROLL_OFFSET : 20,
});

/** Keep tooltips clear of the fixed mobile bottom nav when flipping/shifting. */
export const JOYRIDE_MOBILE_FLOATING_OPTIONS = {
  flipOptions: {
    padding: { top: 12, bottom: 72, left: 12, right: 12 },
  },
  shiftOptions: {
    padding: { top: 12, bottom: 72, left: 12, right: 12 },
  },
};
